import { DialogContent } from '@mui/material';
import React from 'react';

import ChannelMonitoring from '@/components/ChannelContainer/ChannelMonitoring';

interface ChannelMonitoringModalProps {
  channelId: string;
}

const ChannelMonitoringModal = ({ channelId }: ChannelMonitoringModalProps) => {
  return (
    <DialogContent sx={{ p: 2, overflowY: 'auto' }}>
      <ChannelMonitoring channelId={channelId} />
    </DialogContent>
  );
};

export default ChannelMonitoringModal;
